<template>
  <form class="form" method="put">

    <div id="appPublicationEditVueComponent" class="appFontBlack">
      <HeaderApp />
      <div class="appGroupOfDivCreateOrModify">
        <h2>Modifier ma publication Web</h2>
        <div class="appGroupOfDivNamesAndInput">

          <div class="appGroupOfDivNames">
            <p class="appLabelStyle1">Titre*</p>
            <p for="file" class="appLabelStyle1">Image</p>
            <p class="appLabelStyle1">Mon texte*</p>
          </div>

          <div class="appGroupOfInput">
            <input v-model="article.title" type="string" name="title" class="appInputStyle1"
              placeholder="Saisir mon titre ici">
            <input @change="onFileChange()" class="appInputStyle1 appPublicationFileInpout" type="file" ref="file"
              name="file" accept=".jpg, .jpeg, .gif, .png">
            <textarea v-model="article.description" type="string" name="description" class="appInputStyle3"
              placeholder="Saisir ma description ici"></textarea>
            <br>
            <br>
            <div class="appGroupOfInput2">
              <img class="appPublicationImages2" v-bind:src=article.imageUrl>
            </div>
          </div>
        </div>
        <p class="appInputStyle1 appStatisticsTable04">Ne pas faire de saut à la ligne, ou indiquer de "," ou de ":"</p>
      </div>
      <br>
      <button @click.prevent="modifyPublication()" type="submit" class="appButtonModel2">Modifier ma publication</button>
      <button @click.prevent="deletePublication()" type="submit" class="appButtonModel2">Supprimer ma publication</button>
      <div v-show="errorMsg" class="error">{{ errorMsg }}</div>
    </div>

</form></template>

<script>
// Désactiver le problème du camel case avec jwt-decode
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode'
import axios from 'axios'
import HeaderApp from '../Application/HeaderApp.vue'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  components: {
    HeaderApp
  },
  name: 'PublicationEdit',
  data () {
    return {
      date: '',
      title: '',
      description: '',
      imageUrl: '',
      article: '',
      errorMsg: ''
    }
  },
  mounted () {
    const url = document.location.href
    const idToModify = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/articles/' + idToModify), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.article = response.data
      })
  },
  methods: {
    onFileChange () {
      this.file = this.$refs.file.files[0]
      this.newImage = URL.createObjectURL(this.file)
    },
    modifyPublication () {
      if (this.title !== null || this.description !== null) {
        this.errorMsg = ''
        // Si champs tous remplis -Récupérer les données du localStorage
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const decryptedToken = jwt_decode(tokenWithDatas.token)
        const url = document.location.href
        const idToModify = url.substring(url.lastIndexOf('=') + 1)
        // Gestion de la Formdata
        const myForm = new FormData()
        const myDataToCreatePost = {
          'userId': decryptedToken.userId,
          'date': this.article.date,
          'title': this.article.title,
          'description': this.article.description
        }
        myForm.append('article', JSON.stringify(myDataToCreatePost))
        // Partie Image
        const file = this.file
        myForm.append('image', file)
        // Partie Put
        axios
          .put('https://privilegia.fr/api/articles/' + idToModify, myForm, {
            headers: {
              Authorization: 'Bearer ' + tokenWithDatas.token,
              'Content-type': 'multipart/form-data'
            }
          })
          .then((response) => {
            window.alert('Article web modifié')
            this.$router.push('/App/Publications')
          })
          .catch((error) => {
            console.log(error.response.data)
            this.errorMsg = 'Merci de renseigner un titre et une description'
          })
        // Si des champs sont vides
      } else {
        this.errorMsg = 'Merci de renseigner un titre et une description'
      }
    },
    deletePublication () {
      if (window.confirm('Supprimer cet article web ?')) {
        const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
        const url = document.location.href
        const idToDelete = url.substring(url.lastIndexOf('=') + 1)
        axios
          .delete('https://privilegia.fr/api/articles/' + idToDelete,
            { headers: { Authorization: 'Bearer ' + tokenWithDatas.token, 'Content-Type': 'application/json' } })
          .then((response) => {
            window.alert('Article web supprimé')
            this.$router.push('/App/Publications')
          })
          .catch((error) => {
            console.log(error.response.data)
          })
      }
    }
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppPublicationsEdit.vue